
const PlayerVersion = '0.1.0'

 const AVType = {

    Video: 0x1,
    Audio: 0x2

};

 const VideoType = {

    H264: 0x1,
    H265: 0x2
};

const AudioType = {

    PCMA:  0x1,
    PCMU:  0x2,
    AAC:   0x4

};

const AACProfile = {
    AAC_MAIN: 1,
    AAC_LC:   2,
    AAC_SSR:  3
};

const FrameType = {

    YUV:          0x1, //YUV数据
    JSVideoFrame:   0x2, //js videoFrame格式
};


const PixelType = {

    YUV_I420:   0x1,
    YUV_NV12:   0x2,
    RGBA:       0x3,
    DOM:       0x4,
};

const ADTS_HEADER_SIZE = 7;

const AAC_SAMPLE_RATE = [
    96000, 88200, 64000, 48000,
    44100, 32000, 24000, 22050,
    16000, 12000, 11025, 8000,
    7350, 0, 0, 0
  ];




const WORKER_SEND_TYPE = {
    init: 'init',
    setVideoCodec: 'setVideoCodec',
    decodeVideo: 'decodeVideo',
    setAudioCodec: 'setAudioCodec',
    decodeAudio: 'decodeAudio',
    reset: 'reset',
    startRecord: 'startRecord',
    stopRecord: 'stopRecord',
    switchRender: 'switchRender',
    initWorkletMesssagePort: 'initWorkletMesssagePort',
    renderOptionsUpdated: 'renderOptionsUpdated',
    startTalk: 'startTalk',
    stopTalk: 'stopTalk',
    resizeView: 'resizeView',
    updateRenderOptions: 'updateRenderOptions',
    startEncWSSStream:'startEncWSSStream',
    seekTFCardStream:'seekTFCardStream',
    seekCloudStream:'seekCloudStream',
    playScaleStream:'playScaleStream',
    pauseStream:'pauseStream',
    resumeStream:'resumeStream',
    destroy: 'destroy',
}


const WORKER_EVENT_TYPE = {
    created:'created',
    inited:'inited',
    destroyed: 'destroyed',
    updateRenderOptions: 'updateRenderOptions',
    videoInfo: 'videoInfo',
    videoFrame: 'videoFrame',
    audioInfo: 'audioInfo',
    pcmData: 'pcmData',
    recordFinish: 'recordFinish',
    initSegment: 'initSegment',
    mediaSegment: 'mediaSegment',
    updateSAT: 'updateSAT',
    event: 'event',
    playAbnormal: 'playAbnormal',
    requestEncWSSKey: 'requestEncWSSKey',
    logData:'logData'
}

const STREAM_BUSI_TYPE = {
    flv: 'flv',
    hmLiveStream: 'hmlive',
    hmTFCardStream: 'hmtfcard',
    hmCloudStream: 'hmcloud',
    hmWebRtc: 'hmWebRtc',
    hmEncWSSStream: 'hmencwssstream',
}


const TALK_BUSI_TYPE = {
    normalTalk: 'normalTalk',
    dxTalk: 'dxTalk'
}


const ContentFitType = {

    fill:     0,
    contain:  1,
    cover:    2
};


export {AVType, VideoType, AudioType, FrameType, PixelType, ADTS_HEADER_SIZE, AAC_SAMPLE_RATE, AACProfile, WORKER_SEND_TYPE, WORKER_EVENT_TYPE, STREAM_BUSI_TYPE, ContentFitType, PlayerVersion, TALK_BUSI_TYPE};